export default {
  formApiError: {
    id: 'buyback_bank_form_api_error',
    defaultMessage: 'Internal error, please try again.',
  },
}
